import { Modal } from "antd";

let currentModal = null;

export const closeConfirm = () => {
  if (currentModal) {
    currentModal.destroy();
    currentModal = null;
  }
};

export const showConfirm = ({
  title = null,
  content = "",
  okText = "OK",
  cancelText = "Cancel",
  hideCancel = false,
}) => {
  return new Promise((resolve) => {
    Modal.confirm({
      title,
     icon: hideCancel ? null : null,
      centered: true,
     content: (
        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          {typeof content === "string" ? (
            <span dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            content
          )}
        </div>
      ),
      okText,
      cancelText,
      okCancel: !hideCancel,
      cancelButtonProps: hideCancel ? { style: { display: "none" } } : {},
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
};
